import type { Icon } from "@phosphor-icons/react/dist/lib/types";
import { ChartPieIcon } from "@phosphor-icons/react/dist/ssr/ChartPie";
import { CoinsIcon } from "@phosphor-icons/react/dist/ssr/Coins";
import { CreditCardIcon } from "@phosphor-icons/react/dist/ssr/CreditCard";
import { FileTextIcon } from "@phosphor-icons/react/dist/ssr/FileText";
import { GraduationCapIcon } from "@phosphor-icons/react/dist/ssr/GraduationCap";
import { HouseIcon } from "@phosphor-icons/react/dist/ssr/House";
import { PaperPlaneRightIcon } from "@phosphor-icons/react/dist/ssr/PaperPlaneRight";
import { StorefrontIcon } from "@phosphor-icons/react/dist/ssr/Storefront";
import { UsersIcon } from "@phosphor-icons/react/dist/ssr/Users";

/**
 * Nav Icons Registry - HUMANDA Portal
 *
 * Maps icon key strings to Phosphor icon components.
 * Used by the sidebar navigation to render icons.
 */
export const icons = {
	"chart-pie": ChartPieIcon,
	coins: CoinsIcon,
	"credit-card": CreditCardIcon,
	"file-text": FileTextIcon,
	"graduation-cap": GraduationCapIcon,
	house: HouseIcon,
	"paper-plane": PaperPlaneRightIcon,
	storefront: StorefrontIcon,
	users: UsersIcon,
} as Record<string, Icon>;
